var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',_vm._l((8),function(n){return _c('ProductSkeleton',{key:n})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }